import RegionPage from './RegionPage';

export default RegionPage;
